import React from "react";
import theme from "../theme";

interface Props {
  total: number;
  current: number;
}

const ProgressSteps: React.FC<Props> = ({ total, current }) => {
  const steps = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div style={container}>
      {steps.map((n, idx) => (
        <React.Fragment key={n}>
          <div
            style={{
              ...circle,
              /*  ───── change is here ─────  */
              background: n <= current ? theme.colors.primary : "#e9edff",
              color: n <= current ? "#fff" : theme.colors.primary,
            }}
          >
            {n}
          </div>

          {idx < steps.length - 1 && <div style={bar} />}
        </React.Fragment>
      ))}
    </div>
  );
};

const container: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
  marginBottom: 32,
};

const circle: React.CSSProperties = {
  width: 48,
  height: 48,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 18,
};

const bar: React.CSSProperties = {
  flex: 1,
  height: 2,
  background: "#d8ddff",
};

export default ProgressSteps;
